import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthServices from '../services/AuthServices';
import { useNotification } from './NotificationProvider';

import '../styles/ConfirmationInscription.css';

function Preferences() {
  const navigate = useNavigate();
  const { addNotification } = useNotification();
  const [newsletter, setNewsletter] = useState(false);
  const [connexionKey, setKey] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const storedKey = AuthServices.getConnectedKey();
    if (!storedKey) {
      addNotification('Impossible de charger vos preferences sans connexion active.', 'error', 4000);
      return;
    }

    setKey(storedKey);

    fetch(`https://app.listaki.fr/api/WS/getSettingsByKey.php?key=${storedKey}`, {
      method: 'GET',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.success && data.preferences) {
          setNewsletter(Boolean(data.preferences.newsletter));
        } else if (data && data.error) {
          addNotification(data.error, 'error', 4000);
        }
      })
      .catch(() => {
        addNotification('Impossible de charger vos preferences.', 'error', 4000);
      });
  }, [addNotification]);

  const handleSave = () => {
    if (!connexionKey) {
      addNotification("Impossible de trouver votre cle de connexion.", 'error', 4000);
      return;
    }

    const preferences = {
      connexionKey,
      newsletter,
    };

    setIsSaving(true);

    fetch('https://app.listaki.fr/api/WS/save-preferences.php', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(preferences),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.success) {
          addNotification('Preferences mises a jour avec succes.', 'success', 3000);
        } else {
          addNotification("Erreur lors de l'enregistrement des preferences.", 'error', 4000);
        }
      })
      .catch(() => {
        addNotification("Impossible de sauvegarder vos preferences pour le moment.", 'error', 4000);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  return (
    <div className="confirmation-container">
      <button className="continue-button back-button" onClick={() => navigate(-1)}>
        &#8592; Retour
      </button>

      <h1 className="confirmation-title">Mes preferences</h1>

      <p className="confirmation-description">
        Gerez vos preferences de communication pour personnaliser votre experience Listaki.
      </p>

      <div className="preferences-section">
        <div className="preference-item">
          <input
            type="checkbox"
            checked={newsletter}
            onChange={(e) => setNewsletter(e.target.checked)}
            className="preference-checkbox"
            id="newsletter"
          />
          <label htmlFor="newsletter" className="preference-label">
            Je souhaite recevoir les nouveautes et conseils Listaki.
          </label>
        </div>
      </div>

      <button onClick={handleSave} className="continue-button" disabled={isSaving}>
        {isSaving ? 'Enregistrement...' : 'Enregistrer mes preferences'}
      </button>

      <p className="confirmation-footer">
        Vous pourrez revenir ici a tout moment pour modifier vos preferences.
      </p>
    </div>
  );
}

export default Preferences;
